import { USE_MOCKS } from '@/lib/mocks';
import { TermsMockDatasource } from '../data/datasources/terms-mock.datasource';
import { TermsDatasource } from '../data/datasources/terms.datasource';
import { LeadRepositoryImpl } from '../data/repositories/lead.repository.impl';

export const leadContainer = {
  repository: new LeadRepositoryImpl(
    USE_MOCKS ? new TermsMockDatasource() : new TermsDatasource(),
  ),
};
